import React from "react";

/**
 * Renders a Bell icon with optional class.
 *
 * @param {string} cls - optional class for the icon
 * @return {JSX.Element} The Bell icon component
 */
export const BellIcon = ({ cls = "" }) => {
  return (
    <svg
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <path
        d="M21.8146 13.6582L19.8929 6.82296C19.3297 4.82052 18.1056 3.06167 16.4152 1.826C14.7247 0.590322 12.665 -0.0512704 10.5634 0.00320346C8.46186 0.0576773 6.43899 0.805092 4.81639 2.12664C3.19379 3.44819 2.06457 5.26804 1.60824 7.2969L0.120498 13.9111C-0.0438358 14.642 -0.0400364 15.4 0.131616 16.1292C0.303267 16.8584 0.638388 17.5402 1.11224 18.1242C1.58609 18.7082 2.18656 19.1796 2.86933 19.5035C3.55211 19.8273 4.29974 19.9955 5.05704 19.9954H6.18371C6.41584 21.1256 7.03603 22.1417 7.9392 22.8715C8.84238 23.6013 9.97299 24 11.1395 24C12.3059 24 13.4366 23.6013 14.3397 22.8715C15.2429 22.1417 15.8631 21.1256 16.0952 19.9954H16.9428C17.7223 19.9955 18.4914 19.8174 19.1898 19.4749C19.8882 19.1325 20.4971 18.6351 20.9689 18.0215C21.4407 17.408 21.7626 16.6949 21.9094 15.9379C22.0563 15.181 22.0232 14.4008 21.8146 13.6582ZM11.1395 21.9952C10.5142 21.9927 9.90495 21.7992 9.39514 21.4412C8.88534 21.0832 8.49985 20.5783 8.29142 19.9954H13.9875C13.7791 20.5783 13.3936 21.0832 12.8838 21.4412C12.374 21.7992 11.7648 21.9927 11.1395 21.9952ZM19.3579 16.8108C19.0761 17.1804 18.711 17.48 18.2915 17.6857C17.8721 17.8914 17.4099 17.9975 16.9417 17.9957H5.05704C4.60271 17.9956 4.1542 17.8947 3.74461 17.7003C3.33502 17.5059 2.97482 17.2231 2.69057 16.8727C2.40633 16.5223 2.20531 16.1133 2.10236 15.6758C1.9994 15.2383 1.99713 14.7836 2.09572 14.3451L3.58245 7.72985C3.94083 6.13624 4.82776 4.7068 6.10225 3.66877C7.37674 2.63073 8.96563 2.04367 10.6164 2.00092C12.2671 1.95817 13.8849 2.46217 15.2126 3.43281C16.5403 4.40345 17.5017 5.78502 17.944 7.35789L19.8656 14.1931C19.9926 14.6384 20.0128 15.1069 19.9247 15.5613C19.8366 16.0157 19.6425 16.4435 19.3579 16.8108Z"
        fill="currentColor"
      />
    </svg>
  );
};
